export const DRIVER_INPUT_MODES = Object.freeze({
  SYNC: 'sync',
  MANUAL: 'manual',
});

const isNonNegativeInteger = (value) => (
  value !== '' && Number.isInteger(Number(value)) && Number(value) >= 0
);

const isNonNegativeNumber = (value) => (
  value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0
);

export const initialDriverInputMode = (canSync) => (
  canSync ? DRIVER_INPUT_MODES.SYNC : DRIVER_INPUT_MODES.MANUAL
);

export function isDriverInputSubmittable(values) {
  const modeAvailable = values.mode === DRIVER_INPUT_MODES.SYNC
    ? values.canSync
    : values.canManualInput;
  if (!modeAvailable) return false;
  if ((values.mode === DRIVER_INPUT_MODES.MANUAL || values.kind !== 'cat8')
    && !values.asOfDate) return false;
  if (values.mode !== DRIVER_INPUT_MODES.MANUAL) return true;
  if (values.kind === 'cat8') return isNonNegativeNumber(values.totalAreaM2);
  return isNonNegativeInteger(values.totalSeats)
    && isNonNegativeInteger(values.workingDays)
    && Number(values.workingDays) <= 366;
}

export function toDriverInputPayload(values) {
  const payload = {
    mode: values.mode,
    asOfDate: values.asOfDate || undefined,
  };
  if (values.mode !== DRIVER_INPUT_MODES.MANUAL) return payload;
  if (values.kind === 'cat8') {
    return { ...payload, totalAreaM2: values.totalAreaM2 };
  }
  return {
    ...payload,
    totalSeats: Number(values.totalSeats),
    workingDays: Number(values.workingDays),
  };
}
